module.exports = __webpack_public_path__ + "public/img/yuana.b3e2c6e5.png";